import React from 'react'
// libs
import styled from 'styled-components'
import { useRouter } from 'hooks/useRouter'
// components
import { Button, Collapse, BUTTON_LAYOUTS } from 'components/UI'
import PlansList from './components/PlansList'
// views
import { Description, ButtonWrapper } from './view'
// hooks
import { useShowModal } from 'hooks/index'
// constants
import { Modals } from 'constants/modals'
// types
import { IPlan } from 'types/graphql'
// utils
import { get, isEmpty } from 'lodash'
// context
import { CreateReviewBLContext } from 'containers/Review/CreateReview/layers/BL'

// styled
const Wrapper = styled('div')`
  padding: 16px 0;
`

// types
interface IIncomingProps {
  plan: IPlan
}

const LinkedPlans: React.FunctionComponent<IIncomingProps> = ({ plan: currentPlan }) => {
  // hooks
  const [isCollapsed, setCollapsed] = React.useState(false)

  const { isReview } = React.useContext(CreateReviewBLContext)

  const { query, push } = useRouter()

  const { planCreateSubPlan } = currentPlan.currentPermissions

  const { showModal: showCreateSubPlanModal } = useShowModal({ modalType: Modals.SUB_PLAN_CREATE_MODAL })
  const { showModal: showPlanObjectivesListModal } = useShowModal({ modalType: Modals.PLAN_OBJECTIVES_LIST_MODAL })

  // constants
  const parentPlan = get(currentPlan, 'parentPlan')
  const subPlans = get(currentPlan, 'subPlans')
  const linkedPlans = get(currentPlan, 'linkedPlans')
  const totalPlansCount = linkedPlans.length + subPlans.length + (parentPlan && 1)

  // methods
  const onCreateSubPlanClick = () => {
    showCreateSubPlanModal({ parentPlan: currentPlan })
  }

  const showParentPlan = async () => {
    if (isReview) return

    const { id, companyId, planViewMode } = query

    await push(
      {
        pathname: `/plans/${companyId}/edit/${id}`,
        query: {
          parentId: parentPlan.id,
          planViewMode
        }
      },
      undefined,
      { shallow: true }
    )

    showPlanObjectivesListModal({ parentPlan: currentPlan, currentPlan: parentPlan })
  }

  const showLinkedPlan = (plan) => {
    if (isReview) {
      return
    }

    showPlanObjectivesListModal({ parentPlan: currentPlan, currentPlan: plan, isSubPlan: true })
  }

  return (
    <Wrapper>
      <Collapse handleClick={() => setCollapsed(!isCollapsed)} isCollapsed={isCollapsed} className={null}>
        Linked Plans ({totalPlansCount})
      </Collapse>
      {!isCollapsed && (
        <>
          <Description>
            Linking plans allows cascading and aggregation to occur providing a clear line of sight from strategic plans
            through to operational and individual plans
          </Description>

          {planCreateSubPlan && (
            <ButtonWrapper>
              <Button
                type='submit'
                layout={BUTTON_LAYOUTS.PURPLE}
                style={{ borderRadius: '20px', height: '40px' }}
                onClick={onCreateSubPlanClick}
                disabled={isReview}>
                CREATE SUB PLAN
              </Button>
            </ButtonWrapper>
          )}

          {parentPlan && <PlansList onPlanClick={showParentPlan} parentPlan={parentPlan} />}
          {!isEmpty(subPlans) && <PlansList plans={subPlans} onPlanClick={showLinkedPlan} isSubPlans />}
          {!isEmpty(linkedPlans) && <PlansList plans={linkedPlans} onPlanClick={showLinkedPlan} isLinkedPlans />}
        </>
      )}
    </Wrapper>
  )
}

export default LinkedPlans
